export default "/_nuxt/80cfce83f65fc98d21f83d6458d1cdc3.svg";